import { ActionChoice } from './types';

export const normalizeActions = (actions: string[]): ActionChoice[] =>
  (actions ?? []).map((action, index) => ({
    id: index,
    name: action,
  }));
